// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3_-P5","footer":"ModalFilter_footer__17N9j"};